import React, { Component } from "react";
import { Modal } from "semantic-ui-react";
import { connect } from "react-redux";

import ShowImagesForEdit from "../imageVideo/ShowImagesForEdit";
import { closeModal } from "../../actions/modalAction";

const actions = { closeModal };

class ShowImageForEditModal extends Component {
  render() {
    return (
      <Modal
      className="min-max-width"
        //size="tiny"
        open={true}
        onClose={this.props.closeModal}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        style={{
          maxWidth:'700px',
          //background:'transparent',
          backgroundColor: "black",
          margin: "0px",
          padding: "0px",
        }}
      >
        <Modal.Content
          style={{
            //background:'transparent',
            // backgroundColor: "black",
            //opacity: 0.7,
            margin: "0px",
            padding: "0px",
          }}
        >
          <ShowImagesForEdit 
          id={this.props.id} 
          // msg={this.props.msg}
          images={this.props.images}
          apiRoute = {this.props.apiRoute}
          handleRefresh={this.props.handleRefresh} 
          />
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(null, actions)(ShowImageForEditModal);
